/* ------------------------------------------------------------------------
   Google Reviews — NEVERONMONDAY. voor Kings & Queens
   Haalt reviews op via de Google Places API (New), cachet client-side in
   localStorage, en rendert een carousel/grid bovenop de fallback-kaarten
   die server-side al gerenderd zijn vanuit de blocks.
   Volledig geschreven zonder afhankelijkheden, scoped per section-instance.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var FIELD_MASK = [
    'id',
    'displayName',
    'rating',
    'userRatingCount',
    'googleMapsUri',
    'reviews.rating',
    'reviews.text',
    'reviews.relativePublishTimeDescription',
    'reviews.publishTime',
    'reviews.authorAttribution.displayName',
    'reviews.authorAttribution.photoUri'
  ].join(',');

  var STAR_PATH = 'M10 1.5l2.6 5.4 5.9.7-4.3 4.1 1.1 5.9L10 14.8l-5.3 2.8 1.1-5.9L1.5 7.6l5.9-.7L10 1.5Z';

  function cacheKey(placeId) {
    return 'nom-google-reviews:' + placeId;
  }

  function readCache(placeId, maxAgeHours) {
    try {
      var raw = window.localStorage.getItem(cacheKey(placeId));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      var ageMs = Date.now() - parsed.fetchedAt;
      if (ageMs > maxAgeHours * 60 * 60 * 1000) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(placeId, data) {
    try {
      window.localStorage.setItem(
        cacheKey(placeId),
        JSON.stringify({ fetchedAt: Date.now(), data: data })
      );
    } catch (e) {
      /* localStorage niet beschikbaar (privénavigatie e.d.) — negeer, gewoon opnieuw fetchen volgende keer */
    }
  }

  function starsSvg(rating, fillVar, emptyVar) {
    var full = Math.floor(rating);
    var remainder = rating - full;
    var hasHalf = remainder >= 0.25 && remainder < 0.75;
    if (remainder >= 0.75) full += 1;
    var empty = 5 - full - (hasHalf ? 1 : 0);
    if (empty < 0) empty = 0;
    var html = '<span class="nom-gr__stars">';
    for (var i = 0; i < full; i++) {
      html += '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><path fill="' + fillVar + '" d="' + STAR_PATH + '"/></svg>';
    }
    if (hasHalf) {
      var gid = 'nom-half-js-' + Math.random().toString(36).slice(2);
      html += '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><defs><linearGradient id="' + gid + '"><stop offset="50%" stop-color="' + fillVar + '"/><stop offset="50%" stop-color="' + emptyVar + '"/></linearGradient></defs><path fill="url(#' + gid + ')" d="' + STAR_PATH + '"/></svg>';
    }
    for (var j = 0; j < empty; j++) {
      html += '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><path fill="' + emptyVar + '" d="' + STAR_PATH + '"/></svg>';
    }
    html += '</span>';
    return html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function truncate(text, max) {
    if (!text || text.length <= max) return { short: text, isTruncated: false };
    var cut = text.slice(0, max);
    var lastSpace = cut.lastIndexOf(' ');
    if (lastSpace > 40) cut = cut.slice(0, lastSpace);
    return { short: cut + '…', isTruncated: true };
  }

  function buildCard(review) {
    var card = document.createElement('div');
    card.className = 'nom-gr__card';
    card.setAttribute('role', 'listitem');
    card.setAttribute('data-nom-live-card', '');

    var rating = review.rating || 0;
    var text = (review.text && (review.text.text || review.text)) || '';
    var author = (review.authorAttribution && review.authorAttribution.displayName) || '';
    var photo = (review.authorAttribution && review.authorAttribution.photoUri) || '';
    var relTime = review.relativePublishTimeDescription || '';
    var t = truncate(text, 220);

    var avatarHtml = photo
      ? '<img class="nom-gr__card-avatar" src="' + escapeHtml(photo) + '" alt="" loading="lazy" width="36" height="36">'
      : '';

    card.innerHTML =
      '<span class="nom-gr__card-quote" aria-hidden="true">&#8220;</span>' +
      '<div class="nom-gr__card-stars" aria-hidden="true">' + starsSvg(rating, 'var(--nom-gr-star-filled)', 'var(--nom-gr-star-empty)') + '</div>' +
      '<p class="nom-gr__card-text" data-nom-full-text="' + escapeHtml(text) + '">' + escapeHtml(t.short) + '</p>' +
      (t.isTruncated ? '<button type="button" class="nom-gr__card-text-more" data-nom-read-more>Lees meer</button>' : '') +
      '<div class="nom-gr__card-footer">' +
        avatarHtml +
        '<div>' +
          '<div class="nom-gr__card-name">' + escapeHtml(author) + '</div>' +
          (relTime ? '<div class="nom-gr__card-date">' + escapeHtml(relTime) + '</div>' : '') +
        '</div>' +
      '</div>';

    var moreBtn = card.querySelector('[data-nom-read-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var p = card.querySelector('[data-nom-full-text]');
        var expanded = moreBtn.getAttribute('data-expanded') === 'true';
        if (expanded) {
          p.textContent = t.short;
          moreBtn.textContent = 'Lees meer';
          moreBtn.setAttribute('data-expanded', 'false');
        } else {
          p.textContent = text;
          moreBtn.textContent = 'Lees minder';
          moreBtn.setAttribute('data-expanded', 'true');
        }
      });
    }

    return card;
  }

  function initCarouselNav(root) {
    var track = root.querySelector('[data-nom-track]');
    var prev = root.querySelector('[data-nom-prev]');
    var next = root.querySelector('[data-nom-next]');
    if (!track || !prev || !next) return;

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll || maxScroll <= 0;
    }

    function scrollByCard(direction) {
      var card = track.querySelector('.nom-gr__card');
      var amount = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function renderSummary(root, place) {
    var summary = root.querySelector('[data-nom-summary]');
    if (!summary || !place) return;
    var starsEl = summary.querySelector('[data-nom-summary-stars]');
    var scoreEl = summary.querySelector('[data-nom-summary-score]');
    var countEl = summary.querySelector('[data-nom-summary-count]');
    if (starsEl) starsEl.innerHTML = starsSvg(place.rating || 0, 'var(--nom-gr-star-filled)', 'var(--nom-gr-star-empty)');
    if (scoreEl) scoreEl.textContent = (place.rating || 0).toFixed(1);
    if (countEl) countEl.textContent = '(' + (place.userRatingCount || 0) + ' reviews)';
    summary.hidden = false;
  }

  function renderReviews(root, place, minRating, maxReviews) {
    var track = root.querySelector('[data-nom-track]');
    if (!track || !place || !place.reviews) return false;

    var reviews = place.reviews
      .filter(function (r) { return (r.rating || 0) >= minRating; })
      .slice(0, maxReviews);

    if (!reviews.length) return false;

    // Live reviews vervangen de fallback-kaarten.
    track.querySelectorAll('[data-nom-fallback-card]').forEach(function (el) { el.remove(); });

    reviews.forEach(function (review) {
      track.appendChild(buildCard(review));
    });

    return true;
  }

  function setCta(root, place, overrideUrl) {
    var cta = root.querySelector('[data-nom-cta]');
    if (!cta) return;
    var url = overrideUrl || (place && place.googleMapsUri);
    if (url) {
      cta.setAttribute('href', url);
      cta.removeAttribute('aria-disabled');
    }
  }

  function setStatus(root, text, visible) {
    var status = root.querySelector('[data-nom-status]');
    if (!status) return;
    var span = status.querySelector('[data-nom-loading-text]') || status;
    span.textContent = text;
    status.hidden = !visible;
  }

  function init(root) {
    if (root.getAttribute('data-nom-initialized') === 'true') return;
    root.setAttribute('data-nom-initialized', 'true');

    var placeId = root.getAttribute('data-place-id');
    var apiKey = root.getAttribute('data-api-key');
    var sort = root.getAttribute('data-reviews-sort') === 'newest' ? 'newest' : 'most_relevant';
    var maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || 5;
    var minRating = parseInt(root.getAttribute('data-min-rating'), 10) || 1;
    var cacheHours = parseFloat(root.getAttribute('data-cache-hours')) || 24;
    var overrideUrl = root.getAttribute('data-maps-url-override') || '';
    var errorText = root.getAttribute('data-error-text') || 'Reviews konden niet geladen worden.';
    var emptyText = root.getAttribute('data-empty-text') || 'Nog geen reviews.';
    var hasFallback = !!root.querySelector('[data-nom-fallback-card]');

    initCarouselNav(root);

    if (!placeId || !apiKey) {
      // Geen live koppeling ingesteld: fallback-kaarten blijven staan, geen call.
      setStatus(root, '', false);
      if (!hasFallback && window.Shopify && window.Shopify.designMode) {
        setStatus(root, 'Vul een Google Place ID en API key in bij de instellingen van deze sectie.', true);
      }
      return;
    }

    var cached = readCache(placeId, cacheHours);
    if (cached) {
      setStatus(root, '', false);
      var rendered = renderReviews(root, cached, minRating, maxReviews);
      renderSummary(root, cached);
      setCta(root, cached, overrideUrl);
      initCarouselNav(root);
      if (!rendered && !hasFallback) setStatus(root, emptyText, true);
      return;
    }

    setStatus(root, root.querySelector('[data-nom-loading-text]').textContent || 'Reviews laden…', true);

    // Let op: de Places API (New) v1 place-detail endpoint kent geen
    // "reviewsSort" query parameter (geeft een 400 INVALID_ARGUMENT terug
    // als je hem meestuurt). De API levert reviews altijd in haar eigen
    // "most relevant"-volgorde; voor "newest" sorteren we hieronder zelf
    // client-side op publishTime.
    var url = 'https://places.googleapis.com/v1/places/' + encodeURIComponent(placeId);

    fetch(url, {
      method: 'GET',
      headers: {
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': FIELD_MASK
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Google Places API antwoordde met status ' + res.status);
        return res.json();
      })
      .then(function (place) {
        if (sort === 'newest' && place && place.reviews) {
          place.reviews = place.reviews.slice().sort(function (a, b) {
            var ta = a.publishTime ? new Date(a.publishTime).getTime() : 0;
            var tb = b.publishTime ? new Date(b.publishTime).getTime() : 0;
            return tb - ta;
          });
        }
        writeCache(placeId, place);
        setStatus(root, '', false);
        var rendered = renderReviews(root, place, minRating, maxReviews);
        renderSummary(root, place);
        setCta(root, place, overrideUrl);
        initCarouselNav(root);
        if (!rendered && !hasFallback) {
          setStatus(root, emptyText, true);
        }
      })
      .catch(function (err) {
        console.warn('[Google Reviews] kon reviews niet ophalen:', err);
        if (hasFallback) {
          setStatus(root, '', false);
        } else {
          setStatus(root, errorText, true);
        }
      });
  }

  function initAll() {
    document.querySelectorAll('.nom-gr[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-editor: her-initialiseer wanneer deze sectie opnieuw geladen wordt
  // (bv. na het wijzigen van instellingen), en ruim niets op dat de editor
  // zelf al beheert.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.nom-gr[data-section-id]');
    if (root) {
      root.removeAttribute('data-nom-initialized');
      init(root);
    }
  });
})();
